<div [hidden]="isGlobalLoading">
  <mat-button-toggle-group
    [value]="toggleValue"
    appearance="legacy"
    name="activityLogToggle"
    aria-label="activityLogToggle"
    >
    <mat-button-toggle
      (change)="onHistoryLogStateChange($event.value)"
      value="events"
      >Events History</mat-button-toggle
      >
      @if (!userRoles.isInspector()) {
        <mat-button-toggle
          (change)="onHistoryLogStateChange($event.value)"
          value="data"
          >Data Input Log</mat-button-toggle
          >
        }
      </mat-button-toggle-group>
      <mat-card appearance="outlined">
        <mat-card-content>
          @if (toggleValue == 'events') {
            <im-events-history> </im-events-history>
          }
          @if (toggleValue == 'data') {
            <im-data-input-log> </im-data-input-log>
          }
        </mat-card-content>
      </mat-card>
    </div>
    @if (isGlobalLoading) {
      <mat-spinner diameter="32"></mat-spinner>
    }
